import React, { Component } from 'react';
import Sidebar from 'react-sidebar';
import PropTypes from 'prop-types';
import Items from './items/side-menu-items';
import SidebarWorkflowMenuItemsContainer from '../../containers/SidebarWorkflowMenuItemsContainer';
import RenderCompanyLogo from '../commons/RenderCompanyLogo';
import * as MenuTypes from './types';
import Avatar from 'react-avatar';
import SingleLine from '../commons/user/SingleLine';
import moment from 'moment';
import LiveClock from './LiveClock';
import { Select } from 'antd';
import langauges from './langauages';
import { getLanguageTranslations } from '../../actions/company';
import { addTranslationForLanguage, setLanguages } from 'react-localize-redux';

const week = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

class SidebarMenu extends Component {

  getSidebarContent() {
    const { user, isPublic, baseWorkflowRoute, companyDetails: { data }, companyDetails } = this.props;
    const LogoLink = user && user.user && user.user.email ? '/app' : '/login';
    const userInfo = user && user.user;
    let fullName = null;
    if (userInfo && !userInfo.lastName) {
      fullName = `${userInfo.firstName}`
    }
    if (userInfo && userInfo.lastName) {
      fullName = `${userInfo.firstName} ${userInfo.lastName}`;
    }
    if (userInfo && userInfo.firstName === userInfo.lastName) {
      fullName = `${userInfo.firstName} `;
    }

    let MenuComponent = companyDetails && companyDetails.data && companyDetails.data.menuType && MenuTypes[companyDetails.data.menuType];
    if (!MenuComponent) {
      MenuComponent = MenuTypes.LEVEL_ONE;
    }

    const date = moment()
    const dateformat = data && data != null ? data.companySettings.dateformat : '';

    const sidebarDateFormat = companyDetails && companyDetails.data && companyDetails.data.companySettings && companyDetails.data.companySettings.topDateFormat


    return <div>

      <div className='main-sidebar-header'>
        <a href={LogoLink} className="company-logo-container" >
          <RenderCompanyLogo />
        </a>
      </div>

      {
        !isPublic && userInfo && (
          <div className="user-info">
            <SingleLine avatarSize={50} fullName={fullName} email={userInfo.role} {...this.props}>
              <Avatar
                round={true}
                size={50}
                name={fullName}
                email={userInfo.email}
              />
            </SingleLine>
          </div>
        )
      }
      {sidebarDateFormat ?
        <div className="drawerDateTime"><span id="clockbox">{week[date.day()]}, &ensp; {sidebarDateFormat ? date.format(sidebarDateFormat) : date.format("DD-MM-YYYY")} &ensp; </span></div>
        : <div className="drawerDateTime"><span id="clockbox">{week[date.day()]}, &ensp; {dateformat ? date.format("DD-MM-YYYY") : date.format("DD-MM-YYYY")} &ensp; <LiveClock /></span></div>
      }

     {this.props.isDarkThemeEnabled && (
  <div
    className="theme-toggle-sidebar"
    onClick={this.props.toggleTheme}
  >
    <div
      className={`theme-toggle-btn theme-toggle-btn-sidebar ${
        this.props.isDarkTheme ? 'dark' : 'light'
      }`}
    >
      <i
        className={`fa ${
          this.props.isDarkTheme ? 'fa-moon-o' : 'fa-sun-o'
        }`}
      />
    </div>

    <span className="sidebar-theme-toggle-text">
      {this.props.isDarkTheme ? 'Light Mode' : 'Dark Mode'}
    </span>
  </div>
)}
      <div className='main-sidebar-navigation'>
        <SidebarWorkflowMenuItemsContainer isPublic={isPublic} data={data} logout={this.props.logout} baseWorkflowRoute={baseWorkflowRoute} />
      </div>
    </div>
  }
  normalize = (setActiveLanguage, value) => {
    setActiveLanguage(value)
  };
  render() {
    const sidebarContent = this.getSidebarContent();
   
    const styles = {
      root: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden'
      },
      sidebar: {
        width: 220,
        zIndex: 2,
        position: 'absolute',
        top: 0,
        bottom: 0,
        transition: 'transform .3s ease-out',
        WebkitTransition: '-webkit-transform .3s ease-out',
        willChange: 'transform',
        overflowY: 'auto'
      },
      content: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: 'scroll',
        WebkitOverflowScrolling: 'touch',
        transition: 'left .3s ease-out, right .3s ease-out'
      },
      overlay: {
        zIndex: 1,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0,
        visibility: 'hidden',
        transition: 'opacity .3s ease-out, visibility .3s ease-out',
        backgroundColor: 'rgba(0,0,0,.3)'
      },
      dragHandle: {
        zIndex: 1,
        position: 'fixed',
        top: 0,
        bottom: 0
      },
    };
    let possibleValues = this.props.availableLanguages ? this.props.availableLanguages.split(',') : [];
    const options = possibleValues.map(val => {
      return {
        value: val,
        label: langauges[val]
      };
    });
    return <div>
        {this.props.availableLanguages &&   <div className='multilingual_upper_div'>
    <Select
          options={options}
          defaultValue={this.props.currentLanguage}
          style={{ flex: 5 }}
          className='ml-5 opacity-100 multilingual_language_sidebar'
          onChange={this.normalize.bind(this, this.props.setActiveLanguage)} />
      </div>
      }

      <Sidebar rootClassName='sidebar-root' sidebarClassName={this.props.topBarEnabled ? 'sidebar-main-def sidebar-main ' : 'sidebar-main'} contentClassName='sidebar-content' style={styles} sidebar={sidebarContent} docked={true}>
        {
          <div>{this.props.children}</div>
        }
      </Sidebar>
    </div>
  }
}

SidebarMenu.propTypes = {
  translate: PropTypes.func,
  setMenuItem: PropTypes.func
}

export default SidebarMenu;
